<template>
<ValidationObserver class="col" tag="div" ref="form" v-slot="{ invalid, handleSubmit }">
    <Loading />
    <Message />

    <CButton color="link" class="d-block w-100 mt-2 not-focusable" :to="{name: 'stores'}" v-if="joinStoreBtn">مشاهده لیست فروشگاه‌ها</CButton>

    <CForm method="post" @submit.prevent="handleSubmit(submit)">
        <CRow>
            <CCustomSearchableInput
                v-if="selectableActiveStores && !link.id && link.type === LinkType.DEVELOPER"
                col="12"
                vid="store_id"
                :name="$t('link.store_name')"
                v-model="selectedStore"
                required
                rules="required"
                :items="selectableActiveStores"
                addWrapperClasses="mb-0"
            />
            <div class="col-12 position-relative" style="top: -8px" v-if="!link.id && link.type === LinkType.EXCLUSIVE && link.store_id">
                <a :href="stores[link.store_id].website" style="text-decoration:underline;" target="_blank">رفتن به سایت {{ stores[link.store_id].name }}</a>
            </div>

            <CCustomInput
                sm="12"
                vid="title"
                :name="$t('link.title')"
                rules="required"
                required
                v-model="link.title"
            />

            <CCustomInput
                v-if="link.type === LinkType.EXCLUSIVE"
                sm="12"
                vid="href"
                :name="$t('link.href')"
                rules="required|url"
                required
                v-model="link.href"
                ltr
            />

            <CCustomSearchableInput
                v-if="$policy('link').create_any_or_group && !link.id"
                col="12"
                vid="user_id"
                :name="$t('attributes.created_for')"
                v-model="userId"
                required
                rules="required"
                :items="selectableUsers"
            />

            <CCol sm="12">
                <CButton :disabled="invalid" type="submit"  color="primary" class="mt-3 px-4 float-right">{{ $t('submit') }}</CButton>
            </CCol>
        </CRow>

    </CForm>
</ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex'
import { LinkType } from '@/constants'

export default {
    name: 'Form',

    props: {
        submit: {
            default() {},
            required: true,
        },
        link: {
            default() {
                return {
                    title: '',
                    href: '',
                    store_id: null,
                }
            },
        },
    },

    data() {
        return {
            LinkType,
            selectedStore: '',
            userId: '',
            joinStoreBtn: false,
        }
    },

    computed: {
        ...mapGetters({
            selectableActiveStores: 'store/selectableActiveStores',
            stores: 'store/stores',
            selectableUsers: 'user/selectableUsers',
        })
    },

    watch: {
        selectedStore(val) {
            this.link.store_id = val.value || null
        },
        userId(val) {
            this.link.user_id = val.value
        }
    },

    methods: {
        // used in reset form in parent component
        destory() {
            this.selectedStore = ''
        }
    }
}
</script>